// =============================================================================
// IMAGE FALLBACK — handles broken images via data-fallback-parent attribute
// =============================================================================

export function initImageFallback() {
  document.querySelectorAll('img[data-fallback-parent]').forEach(img => {
    img.addEventListener('error', () => {
      const cssClass = img.getAttribute('data-fallback-parent');
      img.parentElement?.classList.add(cssClass);
    }, { once: true });
  });
}
